import { Entities } from '@/entities/api/entities'

const entityConvert = (entity: Entities) => {
	switch (entity) {
		case 'supplements':
			return 'Suplementos'
		case 'plans_personalized':
			return 'Plan personalizado'
		case 'clothes':
			return 'Ropa'
		case 'accessories':
			return 'accesorio'
		default:
			return 'Sin entidad'
	}
}

export default entityConvert
